import { httpClient } from '../httpClient';

/**
 * Classification Admin API -- config, article mappings, NCA.
 * Extracted from classification.js (T117).
 */
export const classificationAdminApi = {
  // ── Article Mappings (CRUD) ─────────────────────────────────────────────
  listArticleMappings: () =>
    httpClient.get('/classification/article-mappings'),

  createArticleMapping: (data) =>
    httpClient.post('/classification/article-mappings', data),

  updateArticleMapping: (id, data) =>
    httpClient.put(`/classification/article-mappings/${id}`, data),

  deleteArticleMapping: (id) =>
    httpClient.delete(`/classification/article-mappings/${id}`),

  // ── Adequate Destinations — REMOVED (Part D) ───────────────────────────
  // The AdequateDestination table and its routes were retired; adequacy is
  // governed solely by the DPTA registry (PDPL Art. 29(2)(b)).

  // ── ML Models — REMOVED (D-05) ─────────────────────────────────────────
  // The ML model registry is Out of Scope; routes/ml.py + MLModelRegistration
  // + registry_service were removed backend-first. The honest replacement is
  // the per-scan engine ledger (GET /classification/scans → engineLedger),
  // surfaced by the Admin "Engine" tab (EngineLedgerPanel).

  // ── NCA Controls ───────────────────────────────────────────────────────
  getNcaControls: (classificationId) =>
    httpClient.get(`/classification/intelligence/nca-controls/${classificationId}`),
};
